import axios from 'axios'


const API_URL = process.env.VUE_APP_API_URL;

class AuthService {
    async login(username, password) {
      return axios
        .post(API_URL + 'login/login', {},
        {
            mode:"cors",
            headers: {
                'Authorization': 'Basic ' + btoa(username + ':' + password)
            }
        })
        .then(response => {
          if (response.data.Token) {
            let utente = {
              Username: response.data.Username,
              Nome: response.data.Nome,
              Cognome: response.data.Cognome,
              Lingua: "EN",
              Token: response.data.Token
            } ;
            localStorage.setItem('utente', JSON.stringify(utente))
            localStorage.setItem('azienda', JSON.stringify(response.data.Azienda));
          }
          return response.data;
        });
    }

    async cambioPassword(token, campioPasswordData){
    
      return axios({
          url: API_URL + 'login/CambioPassword',
          method: "post",
          headers:{
            Authorization: 'Bearer '+ token,
            'Content-Type': 'application/json'
          },
          data: campioPasswordData
      })
      .then(
        data => {
          return data;
        }
      )
      .catch(error => {
        return error.response;
      });
    }

    async recuperoPassword(email){
    
      return axios({
          url: API_URL + 'login/RecuperoPassword',
          method: "post",
          headers:{
            'Content-Type': 'application/json'
          },
          data: JSON.stringify(Buffer.from(email).toString("base64"))
      })
      .then(
        data => {
          return data;
        }
      )
      .catch(error => {
        return error.response;
      });
    }

    async checkLogin(token){
      return axios({
          url: API_URL + 'login/CheckLogin',
          method: "get",
          headers:{
            Authorization: 'Bearer '+ token,
            'Content-Type': 'application/json'
          },
      })
      .then(
        data =>  {
          if(data && data.status == 200){
            return true;
          }
          else{
            return false;
          }
        }
      )
      .catch(error => {
        return false;
      });
    }
  }

  export default new AuthService();